/* Coherencia — interacciones de la tienda (vanilla, sin librerías) */
(function () {
  'use strict';

  /* Cada sección enlaza este archivo: se ejecuta una sola vez */
  if (window.__coherencia) return;
  window.__coherencia = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function listo(el) {
    if (el.dataset.cohReady) return false;
    el.dataset.cohReady = '1';
    return true;
  }
  function cada(scope, selector, fn) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(selector), fn);
  }
  function enVista(el, umbral, dentro, fuera) {
    if (!('IntersectionObserver' in window)) { dentro(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { dentro(); } else if (fuera) { fuera(); } });
    }, { threshold: umbral }).observe(el);
  }

  /* ---------- Aparición al hacer scroll ---------- */
  var revealObserver = null;
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.coh-reveal:not(.is-visible)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    }
    Array.prototype.forEach.call(items, function (el) { revealObserver.observe(el); });
  }

  /* ---------- Manifiesto: palabras que se iluminan con el scroll ---------- */
  var manifiestos = [];
  function initManifiesto(scope) {
    cada(scope, '[data-coh-words]', function (el) {
      if (!listo(el)) return;
      var html = el.innerHTML.replace(/<br\s*\/?>/gi, ' \n ');
      var parts = html.split(/\s+/).filter(Boolean);
      el.innerHTML = parts.map(function (w) {
        return w === '\n' ? '<br>' : '<span class="coh-word">' + w + '</span> ';
      }).join('');
      manifiestos.push(el);
    });
    if (manifiestos.length) updateManifiestos();
  }
  function updateManifiestos() {
    var vh = window.innerHeight;
    manifiestos.forEach(function (el) {
      if (!document.body.contains(el)) return;
      var words = el.querySelectorAll('.coh-word');
      if (reduceMotion) { Array.prototype.forEach.call(words, function (w) { w.classList.add('is-on'); }); return; }
      var r = el.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.25;
      var progress = (start - r.top) / (start - end + r.height * 0.6);
      progress = Math.max(0, Math.min(1, progress));
      var count = Math.round(progress * words.length);
      Array.prototype.forEach.call(words, function (w, i) { w.classList.toggle('is-on', i < count); });
    });
  }

  /* ---------- Gotas de agua ---------- */
  function initGotas(scope) {
    cada(scope, '[data-coh-gotas]', function (layer) {
      if (!listo(layer)) return;
      var total = parseInt(layer.getAttribute('data-coh-gotas'), 10) || 18;
      var seed = 7;
      function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      for (var i = 0; i < total; i++) {
        var d = document.createElement('span');
        d.className = 'coh-gota';
        var size = 6 + rnd() * 22;
        d.style.width = size + 'px';
        d.style.height = (size * (1 + rnd() * 0.25)) + 'px';
        d.style.left = (rnd() * 96) + '%';
        d.style.top = (rnd() * 92) + '%';
        d.style.animationDelay = (rnd() * 6).toFixed(2) + 's';
        layer.appendChild(d);
      }
      var lluvia = layer.parentNode.querySelector('[data-coh-lluvia]');
      if (lluvia && !reduceMotion) {
        for (var j = 0; j < 14; j++) {
          var c = document.createElement('span');
          c.className = 'coh-caida';
          c.style.left = (rnd() * 100) + '%';
          c.style.animationDelay = (rnd() * 5).toFixed(2) + 's';
          c.style.animationDuration = (2.6 + rnd() * 2.4).toFixed(2) + 's';
          lluvia.appendChild(c);
        }
      }
    });
  }

  /* ---------- Ondas al pasar por el agua ---------- */
  function initOndas(scope) {
    if (reduceMotion) return;
    cada(scope, '[data-coh-ondas]', function (zona) {
      if (!listo(zona)) return;
      var ultima = 0;
      function onda(e, fuerte) {
        var r = zona.getBoundingClientRect();
        var s = document.createElement('span');
        s.className = 'coh-ripple' + (fuerte ? ' coh-ripple--fuerte' : '');
        s.style.left = (e.clientX - r.left) + 'px';
        s.style.top = (e.clientY - r.top) + 'px';
        zona.appendChild(s);
        setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 1400);
        zona.classList.add('is-usada');
      }
      zona.addEventListener('pointermove', function (e) {
        var ahora = Date.now();
        if (ahora - ultima < 110) return;
        ultima = ahora;
        onda(e, false);
      });
      zona.addEventListener('pointerdown', function (e) { onda(e, true); });
    });
  }

  /* ---------- Efecto 3D y brillo en la foto principal ---------- */
  function initTilt(scope) {
    if (!finePointer || reduceMotion) return;
    cada(scope, '[data-coh-tilt]', function (el) {
      if (!listo(el)) return;
      var frame = null;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          el.style.setProperty('--ry', ((px - 0.5) * 10).toFixed(2) + 'deg');
          el.style.setProperty('--rx', ((0.5 - py) * 8).toFixed(2) + 'deg');
          el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
          el.classList.add('is-tilting');
        });
      });
      el.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        el.classList.remove('is-tilting');
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(scope) {
    cada(scope, '[data-coh-galeria]', function (gal) {
      if (!listo(gal)) return;
      var main = gal.querySelector('[data-coh-principal]');
      var thumbs = gal.querySelectorAll('[data-coh-thumb]');
      Array.prototype.forEach.call(thumbs, function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.classList.add('is-changing');
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.srcset = btn.getAttribute('data-srcset') || '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.classList.remove('is-changing');
          }, 180);
          Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove('is-active'); t.setAttribute('aria-current', 'false'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Variantes, cantidad y precio ---------- */
  function initCompra(scope) {
    cada(scope, '[data-coh-compra]', function (box) {
      if (!listo(box)) return;

      var qty = box.querySelector('[data-coh-qty]');
      cada(box, '[data-coh-qty-btn]', function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-coh-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      var dataEl = box.querySelector('[data-coh-variantes]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = box.querySelectorAll('[data-coh-opcion]');
      var idInput = box.querySelector('input[name="id"]');
      var price = box.querySelector('[data-coh-precio]');
      var compare = box.querySelector('[data-coh-precio-antes]');
      var button = box.querySelector('[data-coh-boton]');
      var buttonText = button ? button.querySelector('span') : null;
      var comprarYa = box.querySelectorAll('[data-coh-comprar-ya]');

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) {
          var checked = s.querySelector('input:checked');
          return checked ? checked.value : s.value;
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        Array.prototype.forEach.call(comprarYa, function (b) { b.disabled = !(match && match.available); });
        if (!button) return;
        if (!match) {
          button.disabled = true;
          if (buttonText) buttonText.textContent = button.getAttribute('data-texto-nodisponible');
          return;
        }
        if (idInput) idInput.value = match.id;
        if (price) price.innerHTML = match.price;
        if (compare) {
          compare.innerHTML = match.compare || '';
          compare.hidden = !match.compare;
        }
        button.disabled = !match.available;
        if (buttonText) {
          buttonText.textContent = match.available ? button.getAttribute('data-texto') : button.getAttribute('data-texto-agotado');
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', update); });
    });
  }

  /* ---------- Catálogo: filtros por tipo y botón de ver más ---------- */
  function initCatalogo(scope) {
    cada(scope, '[data-coh-catalogo]', function (grid) {
      if (!listo(grid)) return;
      var seccion = grid.closest('.coh-cat');
      if (!seccion) return;
      var botones = seccion.querySelectorAll('[data-coh-filtro]');
      var vacio = seccion.querySelector('[data-coh-cat-vacio]');
      var cajaMas = seccion.querySelector('[data-coh-mas-caja]');
      var botonMas = seccion.querySelector('[data-coh-mas]');
      var verTodo = seccion.querySelector('[data-coh-ver-todo]');
      var paso = parseInt(grid.getAttribute('data-coh-inicial'), 10) || 0;
      var tope = paso;          // cuántas se enseñan ahora mismo (0 = sin tope)
      var filtro = 'todo';

      // Pinta la rejilla según el filtro y el tope, y decide si hace falta el botón.
      function aplicar(animar) {
        var coinciden = 0, mostradas = 0;
        cada(grid, '.coh-card', function (card) {
          var encaja = filtro === 'todo' || card.getAttribute('data-tipo') === filtro;
          if (encaja) coinciden++;
          var cabe = !tope || coinciden <= tope;
          var mostrar = encaja && cabe;
          card.hidden = !mostrar;
          if (mostrar) {
            mostradas++;
            card.classList.add('is-visible');
            if (animar && !reduceMotion) {
              card.classList.remove('is-entrando');
              void card.offsetWidth;
              card.classList.add('is-entrando');
            }
          }
        });
        if (vacio) vacio.hidden = coinciden > 0;
        var quedan = coinciden - mostradas;
        if (cajaMas) cajaMas.hidden = quedan <= 0;
        // El enlace a la colección solo estorba mientras queden joyas por descubrir aquí.
        if (verTodo && cajaMas) verTodo.hidden = quedan > 0;
        if (botonMas) botonMas.setAttribute('aria-label', quedan > 0 ? 'Ver ' + quedan + ' joyas más' : '');
      }

      Array.prototype.forEach.call(botones, function (b) {
        b.addEventListener('click', function () {
          filtro = b.getAttribute('data-coh-filtro');
          Array.prototype.forEach.call(botones, function (o) {
            o.classList.toggle('is-active', o === b);
            o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          tope = paso;          // al cambiar de categoría se vuelve a empezar
          aplicar(true);
        });
      });

      if (botonMas) {
        botonMas.addEventListener('click', function () {
          var antes = grid.querySelectorAll('.coh-card:not([hidden])').length;
          tope += paso;
          aplicar(false);
          // El foco se queda donde el cliente estaba mirando: la primera joya nueva.
          var ahora = grid.querySelectorAll('.coh-card:not([hidden])');
          if (ahora[antes]) {
            var enlace = ahora[antes].querySelector('a');
            if (enlace) enlace.focus({ preventScroll: true });
          }
        });
      }

      if (paso > 0) aplicar(false);
    });
  }

  /* ---------- Probador: las joyas aparecen al mover el ratón ---------- */
  function initProbador(scope) {
    cada(scope, '[data-coh-probador]', function (escena) {
      if (!listo(escena)) return;
      var seccion = escena.closest('.coh-prob');
      var capas = escena.querySelectorAll('[data-coh-capa]');
      var n = capas.length;
      if (!n) return;
      var marcas = escena.querySelectorAll('.coh-prob__marcas span');
      var fichas = seccion ? seccion.querySelectorAll('[data-coh-ficha]') : [];
      var minis = seccion ? seccion.querySelectorAll('[data-coh-prob-mini]') : [];
      var velocidad = parseInt(escena.getAttribute('data-velocidad'), 10) || 2250;
      var actual = -1, usado = false, timer = null;

      function activar(i) {
        i = ((i % n) + n) % n;
        if (i === actual) return;
        actual = i;
        [capas, marcas, fichas, minis].forEach(function (lista) {
          Array.prototype.forEach.call(lista, function (el, j) { el.classList.toggle('is-active', j === i); });
        });
        Array.prototype.forEach.call(minis, function (m, j) { m.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        escena.classList.toggle('modo-burbuja', !!capas[i].querySelector('.coh-prob__burbuja'));
      }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }
      function usar() {
        if (usado) return;
        usado = true;
        escena.classList.add('is-usada');
        parar();
      }
      function empezar() {
        if (usado || reduceMotion || timer || escena.getAttribute('data-auto') !== 'true') return;
        timer = setInterval(function () { activar(actual + 1); }, velocidad);
      }

      escena.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = escena.getBoundingClientRect();
        var i = Math.floor(((e.clientX - r.left) / r.width) * n);
        usar();
        activar(Math.max(0, Math.min(n - 1, i)));
      });
      var inicioX = null;
      escena.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        inicioX = e.clientX;
      });
      escena.addEventListener('pointerup', function (e) {
        if (inicioX === null) return;
        var dx = e.clientX - inicioX;
        inicioX = null;
        usar();
        activar(actual + (dx > 30 ? -1 : 1));
      });
      escena.addEventListener('pointercancel', function () { inicioX = null; });

      Array.prototype.forEach.call(minis, function (m, j) {
        m.addEventListener('click', function () { usar(); activar(j); });
        if (finePointer) m.addEventListener('mouseenter', function () { usar(); activar(j); });
      });

      activar(0);
      enVista(escena, 0.4, empezar, parar);
    });
  }

  /* ---------- Planes: gym, piscina, playa… ---------- */
  function initPlanes(scope) {
    cada(scope, '[data-coh-planes]', function (sec) {
      if (!listo(sec)) return;
      var botones = sec.querySelectorAll('[data-coh-plan]');
      var fotos = sec.querySelectorAll('[data-coh-plan-foto]');
      var n = botones.length;
      if (!n) return;
      var actual = 0, usado = false, timer = null;

      function activar(i) {
        actual = ((i % n) + n) % n;
        Array.prototype.forEach.call(botones, function (b, j) {
          b.classList.toggle('is-active', j === actual);
          b.setAttribute('aria-selected', j === actual ? 'true' : 'false');
        });
        Array.prototype.forEach.call(fotos, function (f, j) { f.classList.toggle('is-active', j === actual); });
      }
      function parar() { if (timer) { clearInterval(timer); timer = null; } }
      function usar() { usado = true; parar(); }
      function empezar() {
        if (usado || reduceMotion || timer || sec.getAttribute('data-auto') !== 'true') return;
        timer = setInterval(function () { activar(actual + 1); }, 2800);
      }
      Array.prototype.forEach.call(botones, function (b, j) {
        b.addEventListener('click', function () { usar(); activar(j); });
        if (finePointer) b.addEventListener('mouseenter', function () { usar(); activar(j); });
      });
      enVista(sec, 0.35, empezar, parar);
    });
  }

  /* ---------- Regalo: la nota de la foto cambia según para quién es ---------- */
  function initRegalo(scope) {
    cada(scope, '[data-coh-regalo]', function (lista) {
      if (!listo(lista)) return;
      var seccion = lista.closest('.coh-regalo');
      var nota = seccion ? seccion.querySelector('[data-coh-nota-destino]') : null;
      var cta = seccion ? seccion.querySelector('[data-coh-regalo-cta]') : null;
      var ctaInicial = cta ? { href: cta.getAttribute('href'), texto: cta.querySelector('span') ? cta.querySelector('span').textContent : '' } : null;
      var opciones = lista.querySelectorAll('.coh-regalo__opcion');
      function aplicarCta(btn) {
        if (!cta || !ctaInicial || !btn) return;
        var enlace = btn.getAttribute('data-coh-enlace');
        var etiqueta = btn.getAttribute('data-coh-enlace-texto');
        cta.setAttribute('href', enlace || ctaInicial.href);
        var span = cta.querySelector('span');
        if (span) span.textContent = etiqueta || ctaInicial.texto;
      }
      var timer = null;
      function activar(btn) {
        if (btn.classList.contains('is-active')) return;
        Array.prototype.forEach.call(opciones, function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-current'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
        aplicarCta(btn);
        var texto = btn.getAttribute('data-coh-nota');
        if (!nota || !texto) return;
        nota.classList.add('is-cambiando');
        clearTimeout(timer);
        timer = setTimeout(function () {
          nota.textContent = texto;
          nota.classList.remove('is-cambiando');
        }, 260);
      }
      Array.prototype.forEach.call(opciones, function (btn) {
        btn.addEventListener('focus', function () { activar(btn); });
        if (finePointer) btn.addEventListener('mouseenter', function () { activar(btn); });
      });
      aplicarCta(lista.querySelector('.coh-regalo__opcion.is-active'));
    });
  }

  /* ---------- Lupa interactiva ---------- */
  function initLupa(scope) {
    cada(scope, '[data-coh-lupa]', function (zona) {
      if (!listo(zona)) return;
      var lente = zona.querySelector('.coh-lupa__lente');
      var vidrio = zona.querySelector('.coh-lupa__vidrio');
      if (!lente || !vidrio) return;
      var puntos = zona.querySelectorAll('[data-coh-punto]');
      var seccion = zona.closest('.coh-lupa');
      var items = seccion ? seccion.querySelectorAll('[data-coh-punto-info]') : [];
      var cerrar = zona.querySelector('[data-coh-lupa-cerrar]');
      var zoom = parseFloat(zona.getAttribute('data-zoom')) || 2.5;
      var pos = { x: 0.5, y: 0.5 };
      var destino = null, animando = false, usada = false, demoTimer = null;

      function pintar() {
        var r = zona.getBoundingClientRect();
        var w = lente.offsetWidth, h = lente.offsetHeight;
        var x = pos.x * r.width, y = pos.y * r.height;
        lente.style.transform = 'translate3d(' + (x - w / 2) + 'px,' + (y - h / 2) + 'px,0)';
        vidrio.style.backgroundSize = (r.width * zoom) + 'px ' + (r.height * zoom) + 'px';
        vidrio.style.backgroundPosition = (-(x * zoom - w / 2)) + 'px ' + (-(y * zoom - h / 2)) + 'px';
      }
      function mostrar() { zona.classList.add('is-on'); }
      function ocultar() { zona.classList.remove('is-on'); }
      function pararDemo() { if (demoTimer) { clearInterval(demoTimer); demoTimer = null; } }
      function marcarUsada() {
        if (usada) return;
        usada = true;
        zona.classList.add('is-usada');
        pararDemo();
      }
      function desdeEvento(e) {
        var r = zona.getBoundingClientRect();
        pos.x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
        pos.y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
        destino = null;
        pintar();
      }
      function irA(x, y) {
        destino = { x: x, y: y };
        pintar();
        mostrar();
        if (animando) return;
        animando = true;
        (function paso() {
          if (!destino) { animando = false; return; }
          pos.x += (destino.x - pos.x) * 0.12;
          pos.y += (destino.y - pos.y) * 0.12;
          if (Math.abs(destino.x - pos.x) < 0.002 && Math.abs(destino.y - pos.y) < 0.002) {
            pos.x = destino.x; pos.y = destino.y; destino = null;
            pintar();
            animando = false;
            return;
          }
          pintar();
          requestAnimationFrame(paso);
        })();
      }
      function activarItem(i) {
        Array.prototype.forEach.call(items, function (it, j) {
          it.classList.toggle('is-active', j === i);
          var b = it.querySelector('button');
          if (b) b.setAttribute('aria-expanded', j === i ? 'true' : 'false');
        });
        Array.prototype.forEach.call(puntos, function (p, j) { p.classList.toggle('is-active', j === i); });
      }
      function irAPunto(i) {
        var p = puntos[i];
        if (!p) return;
        irA(parseFloat(p.getAttribute('data-x')) / 100, parseFloat(p.getAttribute('data-y')) / 100);
        activarItem(i);
      }
      function esControl(e) {
        return e.target && e.target.closest && e.target.closest('[data-coh-punto], [data-coh-lupa-cerrar]');
      }

      zona.addEventListener('pointermove', function (e) {
        if (esControl(e)) return;
        if (e.pointerType === 'mouse' || zona.classList.contains('is-tactil')) {
          marcarUsada();
          desdeEvento(e);
          mostrar();
        }
      });
      zona.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') ocultar();
      });
      zona.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' || esControl(e)) return;
        marcarUsada();
        zona.classList.add('is-tactil');
        desdeEvento(e);
        mostrar();
      });
      if (cerrar) {
        cerrar.addEventListener('click', function (e) {
          e.stopPropagation();
          zona.classList.remove('is-tactil');
          ocultar();
        });
      }
      Array.prototype.forEach.call(puntos, function (p, i) {
        p.addEventListener('click', function (e) {
          e.stopPropagation();
          marcarUsada();
          irAPunto(i);
        });
      });
      Array.prototype.forEach.call(items, function (it, i) {
        var b = it.querySelector('button');
        if (b) b.addEventListener('click', function () { marcarUsada(); irAPunto(i); });
      });

      function empezarDemo() {
        if (usada || reduceMotion || demoTimer) return;
        if (puntos.length) {
          var i = 0;
          irAPunto(0);
          demoTimer = setInterval(function () { i = (i + 1) % puntos.length; irAPunto(i); }, 2600);
        } else {
          var a = 0;
          demoTimer = setInterval(function () { a += 0.9; irA(0.5 + Math.cos(a) * 0.18, 0.55 + Math.sin(a) * 0.18); }, 900);
        }
      }
      if (zona.getAttribute('data-demo') === 'true') {
        enVista(zona, 0.5, empezarDemo, function () { pararDemo(); if (!usada) ocultar(); });
      }
      window.addEventListener('resize', function () { if (zona.classList.contains('is-on')) pintar(); });
    });
  }

  /* ---------- Carrusel de personas (arrastrable) y compra desde la foto ---------- */
  function initPersonas(scope) {
    cada(scope, '[data-coh-personas]', function (pista) {
      if (!listo(pista)) return;
      var seccion = pista.closest('.coh-per');
      var prev = seccion ? seccion.querySelector('[data-coh-per-prev]') : null;
      var next = seccion ? seccion.querySelector('[data-coh-per-next]') : null;
      var barra = seccion ? seccion.querySelector('[data-coh-per-barra]') : null;

      function paso() {
        var card = pista.querySelector('.coh-per__card');
        var gap = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : 300;
      }
      function progreso() {
        var max = pista.scrollWidth - pista.clientWidth;
        var p = max > 0 ? pista.scrollLeft / max : 1;
        if (barra) barra.style.transform = 'scaleX(' + Math.max(0.08, p) + ')';
        if (prev) prev.disabled = pista.scrollLeft < 4;
        if (next) next.disabled = max <= 4 || pista.scrollLeft > max - 4;
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      pista.addEventListener('scroll', function () { window.requestAnimationFrame(progreso); }, { passive: true });
      window.addEventListener('resize', progreso);
      progreso();

      var drag = null, movido = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('button, a, input, form, .coh-look')) return;
        drag = { x: e.clientX, left: pista.scrollLeft };
        movido = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!movido && Math.abs(dx) > 5) { movido = true; pista.classList.add('is-dragging'); }
        if (movido) pista.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        drag = null;
        pista.classList.remove('is-dragging');
        setTimeout(function () { movido = false; }, 0);
      });
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      cada(pista, '[data-coh-hotspot]', function (btn) {
        var look = btn.parentNode.querySelector('[data-coh-look]');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var abierto = !btn.classList.contains('is-open');
          cada(pista, '[data-coh-hotspot].is-open', function (otro) {
            otro.classList.remove('is-open');
            otro.setAttribute('aria-expanded', 'false');
            var l = otro.parentNode.querySelector('[data-coh-look]');
            if (l) l.classList.remove('is-open');
          });
          btn.classList.toggle('is-open', abierto);
          btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
          if (look) look.classList.toggle('is-open', abierto);
        });
      });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-coh-barra]');
    if (!barra || !listo(barra)) return;
    var desde = parseInt(barra.getAttribute('data-desde'), 10) || 600;
    var visibles = [];

    function refrescar() {
      var mostrar = (window.scrollY > desde && visibles.length === 0) || barra.classList.contains('is-forzada');
      barra.classList.toggle('is-visible', mostrar);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = visibles.indexOf(en.target);
          if (en.isIntersecting && i === -1) visibles.push(en.target);
          if (!en.isIntersecting && i !== -1) visibles.splice(i, 1);
        });
        refrescar();
      });
      cada(document, '[data-coh-cta], footer', function (el) {
        if (!barra.contains(el)) io.observe(el);
      });
    }
    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { refrescar(); pendiente = false; });
    }, { passive: true });
    refrescar();
  }

  /* ---------- El chat de Shopify no debe tapar los botones de compra ----------
     <shopify-chat> es el chat nativo de Shopify: un botón flotante abajo a la
     derecha, con z-index 2147483000, que se superponía al botón "Comprar ahora"
     de la barra fija y al de la propia ficha en móvil.
     El componente expone la variable pública --shopify-chat-activator-offset
     (su hoja interna hace bottom: calc(var(--shopify-chat-activator-offset)...)),
     así que basta con subirlo lo justo para librar lo que tenga debajo.
     No se oculta nunca: sigue siendo accesible en toda la página. */
  var chatListo = false;
  function initChat() {
    if (chatListo) return;   // una sola vez, aunque el editor recargue secciones
    chatListo = true;
    var SEPARACION = 16;   // hueco entre el chat y el control que esquiva
    var BASE = 20;         // posición original de Shopify
    var TOPE = 320;        // nunca lo subimos más que esto
    // DURAS: controles de compra. El chat no puede taparlos nunca.
    var DURAS = '[data-coh-cta], form[action*="/cart/add"], shopify-product-form, .coh-card__btn, .coh-rapida__botones, [data-coh-barra].is-visible';
    // BLANDAS: además, la fila de garantías con los iconos de pago. Se esquiva
    // solo si al hacerlo no acabamos tapando un control de compra: más vale
    // ocultar un icono que el botón de comprar.
    var BLANDAS = DURAS + ', .coh-prod__garantias';
    var chat = null;
    var nudgeCache = null;
    var ultimo = null;
    var pendiente = false;
    var relojFin = null;

    // El botón del chat vive dentro de shadow DOM, y Shopify ha cambiado ya una
    // vez cuántos niveles hay por encima (ahora cuelga de <shopify-agent-runtime>).
    // Por eso se busca en profundidad en vez de en una ruta fija: así el día que
    // vuelvan a moverlo, esto sigue encontrándolo.
    function buscarNudge(raiz, prof) {
      if (!raiz || prof > 6 || !raiz.querySelector) return null;
      var n = raiz.querySelector('.activator-nudge');
      if (n) return n;
      var hijos = raiz.querySelectorAll('*');
      for (var i = 0; i < hijos.length; i++) {
        if (hijos[i].shadowRoot) {
          var r = buscarNudge(hijos[i].shadowRoot, prof + 1);
          if (r) return r;
        }
      }
      return null;
    }

    function recolocar() {
      if (!chat) {
        chat = document.querySelector('shopify-chat');
        if (!chat) return;
      }
      var nudge = nudgeCache;
      if (!nudge || !nudge.isConnected) {
        nudge = nudgeCache = chat.shadowRoot ? buscarNudge(chat.shadowRoot, 0) : null;
      }
      if (!nudge) return;
      var c = nudge.getBoundingClientRect();
      if (!c.width) return;
      var alto = window.innerHeight;

      // Suelo mínimo: la barra fija entra deslizándose, así que su posición
      // durante la animación se queda corta. Su altura sí es fiable.
      var suelo0 = BASE;
      var barra = document.querySelector('[data-coh-barra]');
      if (barra && barra.classList.contains('is-visible')) {
        var hb = barra.offsetHeight;
        if (hb && hb + SEPARACION > suelo0) suelo0 = hb + SEPARACION;
      }

      // ¿El chat, colocado a este desplazamiento, pisa alguna de estas zonas?
      function choca(off, zonas) {
        var techo = alto - off - c.height, base = alto - off;
        for (var i = 0; i < zonas.length; i++) {
          var r = zonas[i].getBoundingClientRect();
          if (!r.width || !r.height) continue;
          if (r.right <= c.left || r.left >= c.right) continue;
          if (r.bottom <= techo || r.top >= base) continue;
          return true;
        }
        return false;
      }
      // Sube el chat hasta que no pise nada. Al subir puede chocar con algo que
      // antes le quedaba encima, por eso se repite hasta que deja de moverse.
      function calcular(zonas) {
        var off = suelo0;
        for (var pase = 0; pase < 5; pase++) {
          var techo = alto - off - c.height, base = alto - off, nuevo = off;
          for (var i = 0; i < zonas.length; i++) {
            var r = zonas[i].getBoundingClientRect();
            if (!r.width || !r.height) continue;
            if (r.right <= c.left || r.left >= c.right) continue;
            if (r.bottom <= techo || r.top >= base) continue;
            var necesario = alto - r.top + SEPARACION;
            if (necesario > nuevo) nuevo = necesario;
          }
          if (nuevo === off) break;
          off = nuevo;
          if (off > TOPE) break;
        }
        return off;
      }

      var duras = document.querySelectorAll(DURAS);
      var offset = Math.min(calcular(duras), TOPE);
      // El extra por la fila de garantías solo se aplica si cabe y si no acaba
      // tapando un botón de compra. Si no, se queda como estaba.
      var conBlandas = calcular(document.querySelectorAll(BLANDAS));
      if (conBlandas <= TOPE && !choca(conBlandas, duras)) offset = conBlandas;

      if (offset === ultimo) return;
      ultimo = offset;
      chat.style.setProperty('--shopify-chat-activator-offset', offset + 'px');
    }

    function pedir() {
      // Una pasada ya, y otra al parar: la barra y los acordeones mueven cosas
      // después del último evento de scroll.
      if (relojFin) window.clearTimeout(relojFin);
      relojFin = window.setTimeout(recolocar, 420);
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { recolocar(); pendiente = false; });
    }

    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir, { passive: true });
    // El chat lo inyecta Shopify después de cargar la página: lo esperamos.
    // Se espera a tener el BOTÓN, no solo el contenedor: Shopify monta los
    // shadow roots internos más tarde, y pararse antes dejaba el chat sin colocar.
    var intentos = 0;
    var reloj = window.setInterval(function () {
      intentos++;
      if (!chat) chat = document.querySelector('shopify-chat');
      recolocar();
      if ((nudgeCache && nudgeCache.isConnected) || intentos > 40) window.clearInterval(reloj);
    }, 500);
    pedir();
  }

  /* ---------- Añadir al carrito sin salir de la página ---------- */
  var toastTimer = null;
  function toast(ok, mensaje, imagen) {
    var t = document.querySelector('[data-coh-toast]');
    if (!t) {
      if (!ok && mensaje) window.alert(mensaje);
      return;
    }
    var titulo = t.querySelector('[data-coh-toast-titulo]');
    var msg = t.querySelector('[data-coh-toast-msg]');
    var img = t.querySelector('[data-coh-toast-img]');
    t.classList.toggle('is-error', !ok);
    if (titulo) titulo.textContent = titulo.getAttribute(ok ? 'data-ok' : 'data-error');
    if (msg) msg.textContent = mensaje || '';
    if (img) {
      if (ok && imagen) { img.src = imagen; img.hidden = false; } else { img.hidden = true; }
    }
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 6500);
  }

  function actualizarCarrito() {
    return fetch(root + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : html;
        el.classList.remove('coh-bote');
        void el.offsetWidth;
        el.classList.add('coh-bote');
      })
      .catch(function () {});
  }

  function volar(form) {
    if (reduceMotion) return;
    var destino = document.getElementById('cart-icon-bubble');
    var zona = form.closest('.coh-card, .coh-prob__ficha, .coh-look, .coh-barra, .shopify-section');
    var img = zona ? zona.querySelector('img') : null;
    if (!destino || !img) return;
    var a = img.getBoundingClientRect();
    var b = destino.getBoundingClientRect();
    if (!a.width || !b.width || b.bottom < 0) return;
    var size = Math.min(110, a.width, a.height);
    var clon = document.createElement('img');
    clon.src = img.currentSrc || img.src;
    clon.alt = '';
    clon.className = 'coh-vuela';
    clon.style.width = size + 'px';
    clon.style.height = size + 'px';
    clon.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    clon.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(clon);
    if (!clon.animate) { clon.parentNode.removeChild(clon); return; }
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var anim = clon.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px) scale(.65)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.2 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () { if (clon.parentNode) clon.parentNode.removeChild(clon); };
  }

  function initCarritoRapido() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-coh-ajax')) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();

      var boton = e.submitter || form.querySelector('[type="submit"]');
      var comprarYa = !!(boton && boton.hasAttribute('data-coh-comprar-ya'));
      var datos = new FormData(form);
      datos.delete('return_to');

      function liberar() {
        if (boton) { boton.classList.remove('is-loading'); boton.disabled = false; }
      }
      if (boton) { boton.classList.add('is-loading'); boton.disabled = true; }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: datos
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (res.ok) {
            if (comprarYa) { window.location.href = root + 'checkout'; return; }
            volar(form);
            actualizarCarrito();
            toast(true, res.d.product_title || '', res.d.image);
            liberar();
            return;
          }
          var mensaje = res.d.description || res.d.message || '';
          if (comprarYa) {
            /* Si ya estaba en el carrito (p. ej. última unidad), vamos a pagar igualmente */
            return fetch(root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (cart.item_count > 0) { window.location.href = root + 'checkout'; }
                else { toast(false, mensaje); liberar(); }
              });
          }
          toast(false, mensaje);
          liberar();
        })
        .catch(function () {
          liberar();
          form.removeAttribute('data-coh-ajax');
          if (form.requestSubmit && boton) { form.requestSubmit(boton); } else { form.submit(); }
        });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-coh-toast-cerrar]')) {
        var t = document.querySelector('[data-coh-toast]');
        if (t) t.classList.remove('is-visible');
      }
    });
  }

  /* ---------- Tarjeta de sellos (descuento tras 3 compras) ---------- */
  var sellosEditor = false;
  function initSellos(scope) {
    cada(scope, '[data-coh-sellos]', function (dlg) {
      if (!listo(dlg)) return;
      var ultimoFoco = null;
      function abrir() {
        ultimoFoco = document.activeElement;
        dlg.hidden = false;
        void dlg.offsetWidth;
        dlg.classList.add('is-open');
        document.documentElement.classList.add('coh-sin-scroll');
        var cerrar = dlg.querySelector('.coh-sellos__cerrar');
        if (cerrar) cerrar.focus();
      }
      function cerrar() {
        if (dlg.hidden) return;
        dlg.classList.remove('is-open');
        document.documentElement.classList.remove('coh-sin-scroll');
        setTimeout(function () { if (!dlg.classList.contains('is-open')) dlg.hidden = true; }, 350);
        if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
      }
      cada(document, '[data-coh-sellos-abrir][aria-controls="' + dlg.id + '"]', function (b) { b.addEventListener('click', abrir); });
      cada(dlg, '[data-coh-sellos-cerrar]', function (b) { b.addEventListener('click', cerrar); });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

      var copiar = dlg.querySelector('[data-coh-copiar]');
      if (copiar) {
        copiar.addEventListener('click', function () {
          var codigo = dlg.querySelector('[data-coh-codigo]');
          var texto = codigo ? codigo.textContent.trim() : '';
          var original = copiar.textContent;
          function hecho() {
            copiar.textContent = copiar.getAttribute('data-copiado');
            setTimeout(function () { copiar.textContent = original; }, 1800);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(texto).then(hecho, hecho);
          } else if (codigo) {
            var rango = document.createRange();
            rango.selectNodeContents(codigo);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(rango);
            try { document.execCommand('copy'); } catch (e) {}
            hecho();
          }
        });
      }
      dlg.__cohAbrir = abrir;
      dlg.__cohCerrar = cerrar;
    });

    if (!sellosEditor) {
      sellosEditor = true;
      document.addEventListener('shopify:section:select', function (e) {
        var d = e.target.querySelector && e.target.querySelector('[data-coh-sellos]');
        if (d && d.__cohAbrir) d.__cohAbrir();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        var d = e.target.querySelector && e.target.querySelector('[data-coh-sellos]');
        if (d && d.__cohCerrar) d.__cohCerrar();
      });
    }
  }

  /* ---------- Nombre grande de la marca: se escribe al entrar y brilla con el ratón ---------- */
  function initMarca(scope) {
    cada(scope, '[data-coh-marca]', function (el) {
      if (!listo(el)) return;
      var mostrar = function () { el.classList.add('is-lista'); };
      if (reduceMotion) { mostrar(); } else { enVista(el, 0.2, function () { window.requestAnimationFrame(mostrar); }); }
      if (!finePointer || reduceMotion) return;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--coh-mx', (100 - ((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.classList.add('is-hover');
      });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-hover'); });
    });
  }

  /* ---------- Hojas de otoño cayendo por toda la web ---------- */
  function initHojas(scope) {
    cada(scope, '[data-coh-hojas]', function (canvas) {
      if (!listo(canvas)) return;
      if (reduceMotion || !canvas.getContext || typeof Path2D === 'undefined') { canvas.style.display = 'none'; return; }
      var ctx = canvas.getContext('2d');
      var d = canvas.dataset;
      var movil = window.matchMedia('(max-width: 749px)').matches;
      var total = parseInt(movil ? d.cantidadMovil : d.cantidad, 10) || 0;
      if (!ctx || !total) { canvas.style.display = 'none'; return; }
      var tMin = parseFloat(d.tamanoMin) || 11;
      var tMax = Math.max(tMin, parseFloat(d.tamanoMax) || 21);
      var vel = parseFloat(d.velocidad) || 60;
      var alfa = (parseFloat(d.opacidad) || 95) / 100;
      var interactivo = d.viento === 'true';
      var colores = (d.colores || '#D9772B,#B5452A,#D9A441,#8C5A2B').split(',');
      var arce = new Path2D('M12 1l1.6 4.6 3.2-1.2-1 4.2 4.8-1-1.8 3.6 3.8 1.2-5.2 2.6 1 3-5.4-1.2-.2 5.8h-1.6l-.2-5.8-5.4 1.2 1-3-5.2-2.6 3.8-1.2-1.8-3.6 4.8 1-1-4.2 3.2 1.2z');
      var ovalada = new Path2D('M12 1.5c6.5 5 6.8 14.5 0 21-6.8-6.5-6.5-16 0-21z');
      var nervio = new Path2D('M12 4.5V23');
      var W = 0, H = 0, dpr = 1;

      function medir() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
      }
      function nueva(alEmpezar) {
        var t = tMin + Math.random() * (tMax - tMin);
        return {
          x: Math.random() * W,
          y: alEmpezar ? Math.random() * H : -t * 2 - Math.random() * H * 0.25,
          t: t,
          vy: (0.55 + Math.random() * 0.8) * vel * (0.7 + (t / tMax) * 0.45),
          vx: 0,
          fase: Math.random() * Math.PI * 2,
          balanceo: 18 + Math.random() * 42,
          fvel: 0.8 + Math.random() * 1.5,
          ang: Math.random() * Math.PI * 2,
          giro: (Math.random() - 0.5) * 2.6,
          vuelta: Math.random() * Math.PI * 2,
          vvel: 1.5 + Math.random() * 3.2,
          color: colores[Math.floor(Math.random() * colores.length)],
          forma: Math.random() < 0.62 ? arce : ovalada
        };
      }

      medir();
      var hojas = [];
      for (var i = 0; i < total; i++) hojas.push(nueva(true));
      var viento = 0;
      var raton = { x: -9999, y: -9999, vx: 0 };
      var ultimoScroll = window.scrollY;
      var ultimo = 0;

      window.addEventListener('resize', medir);
      if (interactivo) {
        window.addEventListener('pointermove', function (e) {
          raton.vx = e.clientX - raton.x;
          raton.x = e.clientX;
          raton.y = e.clientY;
        }, { passive: true });
        window.addEventListener('scroll', function () {
          var dy = window.scrollY - ultimoScroll;
          ultimoScroll = window.scrollY;
          viento += Math.max(-60, Math.min(60, dy)) * 1.4;
        }, { passive: true });
      }
      document.addEventListener('visibilitychange', function () { ultimo = 0; });

      function frame(ts) {
        if (!document.body.contains(canvas)) return;
        var dt = ultimo ? Math.min(0.05, (ts - ultimo) / 1000) : 0.016;
        ultimo = ts;
        viento *= 0.94;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H);
        for (var k = 0; k < hojas.length; k++) {
          var h = hojas[k];
          h.fase += h.fvel * dt;
          h.vuelta += h.vvel * dt;
          h.ang += h.giro * dt;
          if (interactivo) {
            var dx = h.x - raton.x, dy = h.y - raton.y, dist2 = dx * dx + dy * dy;
            if (dist2 < 8100) {
              var fuerza = 1 - Math.sqrt(dist2) / 90;
              h.vx += (raton.vx * 6 + dx * 3) * fuerza * dt * 10;
              h.giro += raton.vx * 0.002 * fuerza;
            }
          }
          h.vx *= 0.96;
          h.giro = Math.max(-6, Math.min(6, h.giro));
          h.x += (Math.cos(h.fase) * h.balanceo * h.fvel + h.vx + viento) * dt;
          h.y += h.vy * dt;
          if (h.y > H + h.t * 2 || h.x < -90 || h.x > W + 90) { hojas[k] = nueva(false); continue; }
          var escala = h.t / 24;
          var volteo = Math.cos(h.vuelta);
          if (Math.abs(volteo) < 0.18) volteo = volteo < 0 ? -0.18 : 0.18;
          ctx.save();
          ctx.translate(h.x, h.y);
          ctx.rotate(h.ang);
          ctx.scale(escala * volteo, escala);
          ctx.translate(-12, -12);
          ctx.globalAlpha = alfa;
          ctx.fillStyle = h.color;
          ctx.fill(h.forma);
          ctx.globalAlpha = alfa * 0.4;
          ctx.strokeStyle = '#3C1E0A';
          ctx.lineWidth = 1.1;
          ctx.stroke(nervio);
          ctx.restore();
        }
        raton.vx *= 0.5;
        window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initManifiesto(scope);
    initGotas(scope);
    initOndas(scope);
    initTilt(scope);
    initGaleria(scope);
    initCompra(scope);
    initCatalogo(scope);
    initProbador(scope);
    initPlanes(scope);
    initRegalo(scope);
    initLupa(scope);
    initPersonas(scope);
    initSellos(scope);
    initMarca(scope);
    initHojas(scope);
    initBarra();
    initChat();
  }

  var pendienteManifiesto = false;
  window.addEventListener('scroll', function () {
    if (pendienteManifiesto || !manifiestos.length) return;
    pendienteManifiesto = true;
    window.requestAnimationFrame(function () { updateManifiestos(); pendienteManifiesto = false; });
  }, { passive: true });
  window.addEventListener('resize', function () { if (manifiestos.length) updateManifiestos(); });

  /* ---------- Títulos de Judge.me en castellano de la casa ----------
     Judge.me no deja cambiar estos dos títulos sin plan de pago, así que se
     reescribe SOLO el texto visible. No toca datos, ni estrellas, ni reseñas:
     si Judge.me cambia su maquetación o el texto de origen, no se hace nada y
     se queda el título original. */
  var TITULOS_JM = [
    { sel: '.jm-review-widget-minimal-header__title', de: 'Reseñas de Clientes', a: 'Opiniones de quienes ya la tienen' },
    { sel: '.jdgm-cards-carousel .jdgm-title', de: 'Customers are saying', a: 'Lo que dicen de Coherencia' }
  ];
  function renombrarTitulosJM() {
    for (var i = 0; i < TITULOS_JM.length; i++) {
      var t = TITULOS_JM[i];
      var els = document.querySelectorAll(t.sel);
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        if (el.getAttribute('data-coh-titulo') === 'si') continue;
        // Solo se cambia si el texto es exactamente el que esperamos.
        if ((el.textContent || '').trim() !== t.de) continue;
        el.textContent = t.a;
        el.setAttribute('data-coh-titulo', 'si');
      }
    }
  }
  function initTitulosJM() {
    if (!window.MutationObserver) { renombrarTitulosJM(); return; }
    renombrarTitulosJM();
    var pendiente = false;
    var obs = new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { renombrarTitulosJM(); pendiente = false; });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // Judge.me pinta en cuanto carga; pasados 30 s ya no hace falta vigilar.
    window.setTimeout(function () { obs.disconnect(); renombrarTitulosJM(); }, 30000);
  }

  initCarritoRapido();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); initTitulosJM(); });
  } else {
    initAll(document);
    initTitulosJM();
  }

  /* Editor de Shopify */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var b = e.target.querySelector && e.target.querySelector('[data-coh-barra]');
    if (b) b.classList.add('is-forzada', 'is-visible');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var b = e.target.querySelector && e.target.querySelector('[data-coh-barra]');
    if (b) b.classList.remove('is-forzada', 'is-visible');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.coh-per__card');
    if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });
})();
